import { Box, Typography, Button } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

export default function Forbidden() {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>403 Forbidden</title>
            </Helmet>

            <Box textAlign={"center"} color={"primary.contrastText"}>
                <Typography variant="h1">403</Typography>
                <h1>
                    Forbidden, you are not authorised to view this page. Please
                    log in
                </h1>
                <Button
                    color="secondary"
                    variant="contained"
                    onClick={() => {
                        navigate("/");
                    }}
                    sx={{ m: 2 }}
                >
                    Log in
                </Button>
            </Box>
        </>
    );
}
